import { render, staticRenderFns } from "./BillingStatementDetailListTable.vue?vue&type=template&id=63268604&scoped=true&lang=pug"
import script from "./BillingStatementDetailListTable.vue?vue&type=script&lang=js"
export * from "./BillingStatementDetailListTable.vue?vue&type=script&lang=js"
import style0 from "./BillingStatementDetailListTable.vue?vue&type=style&index=0&id=63268604&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63268604",
  null
  
)

export default component.exports